<template>
  <div class="auth-page">
    <UcariHeader />
    <main class="system-page"><section class="system-card">
      <span class="system-card__icon system-card__icon--success" uk-icon="icon: mail; ratio: 1.5"></span>
      <span class="eyebrow">One more step</span>
      <h1>Verify your email</h1>
      <p>Thanks for applying. We sent a verification link from <strong>do-not-reply@ucari.com</strong> to your email address.</p>
      <p class="system-card__note">Don’t see it? Check your spam or junk folder before requesting another email.</p>
      <router-link to="/login" class="uk-button uk-button-default">Return to sign in</router-link>
    </section></main>
    <RetailerFooter />
  </div>
</template>

<script>
import UcariHeader from './components/UcariHeader.vue';
import RetailerFooter from './components/RetailerFooter.vue';

export default {
  components: { UcariHeader, RetailerFooter },
  created() {
    document.title = 'Partner Account Registration Confirmation | UCARI';
  },  
};
</script>
